function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import ReactDatePicker from "react-datepicker";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Action, Placeholder, Information, OrganizationScopes } from '../commons/IntlMessages';
import CustomDateComponent from "./CustomDateComponent";
import moment from "moment";
import { Jodit } from "jodit";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);

var SPACE_REG_EXP = function SPACE_REG_EXP() {
  return /[\s\n\t\r\uFEFF\u200b]+/g;
}; // ユーザー登録モーダル

/**
 * モード
 */


export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 3] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    var nowStart = moment(Utility.parseMoment(moment(), 0, 0));
    var nowEnd = nowStart.clone().add('days', 1);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          InformationId: "",
          Title: "",
          Contents: "",
          ContentsEditor: null,
          StartDate: nowStart,
          StartTimeHours: nowStart.hours(),
          StartTimeMinutes: nowStart.minutes(),
          EndDate: nowEnd,
          EndTimeHours: nowEnd.hours(),
          EndTimeMinutes: nowEnd.minutes(),
          OrganizationId: 0,
          ErrorMessages: []
        };
        break;

      case Mode.Modify:
        if (!_this.props.startDateTime || !_this.props.endDateTime) {
          throw Error();
        }

        _this.state = {
          Modal: null,
          InformationId: _this.props.informationId,
          Title: _this.props.title,
          Contents: _this.props.contents,
          ContentsEditor: null,
          StartDate: Utility.ToMoment(_this.props.startDateTime),
          StartTimeHours: Number(Utility.ToMoment(_this.props.startDateTime).format("HH")),
          StartTimeMinutes: Number(Utility.ToMoment(_this.props.startDateTime).format("mm")),
          EndDate: Utility.ToMoment(_this.props.endDateTime),
          EndTimeHours: Number(Utility.ToMoment(_this.props.endDateTime).format("HH")),
          EndTimeMinutes: Number(Utility.ToMoment(_this.props.endDateTime).format("mm")),
          OrganizationId: !_this.props.organizationId ? 0 : _this.props.organizationId,
          ErrorMessages: []
        };
        break;

      case Mode.ReadOnly:
        if (!_this.props.startDateTime || !_this.props.endDateTime) {
          throw Error();
        }

        _this.state = {
          Modal: null,
          InformationId: _this.props.informationId,
          Title: _this.props.title,
          Contents: _this.props.contents,
          ContentsEditor: null,
          StartDate: Utility.ToMoment(_this.props.startDateTime),
          StartTimeHours: Number(Utility.ToMoment(_this.props.startDateTime).format("HH")),
          StartTimeMinutes: Number(Utility.ToMoment(_this.props.startDateTime).format("mm")),
          EndDate: Utility.ToMoment(_this.props.endDateTime),
          EndTimeHours: Number(Utility.ToMoment(_this.props.endDateTime).format("HH")),
          EndTimeMinutes: Number(Utility.ToMoment(_this.props.endDateTime).format("mm")),
          OrganizationId: !_this.props.organizationId ? 0 : _this.props.organizationId,
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    return _this;
  }
  /**
   * タイトルを更新します。
   *
   * @param e イベント
   */


  _createClass(MainComponent, [{
    key: "updateTitle",
    value: function updateTitle(e) {
      this.setState({
        Title: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 内容を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateContents",
    value: function updateContents(e) {
      this.setState({
        Contents: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 配信先を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateInformationScope",
    value: function updateInformationScope(e) {
      this.setState({
        OrganizationId: Number(e.target.value)
      });
    }
    /**
     * 開始日を更新します。
     *
     * @param d 開始日
     */

  }, {
    key: "updateStartDate",
    value: function updateStartDate(d) {
      this.setState({
        StartDate: d
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      var _this2 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;
        var startDateTime = Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes);
        var endDateTime = Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes);

        if (this.state.ContentsEditor != null) {
          var text = this.state.ContentsEditor.text;
          var chars = text.replace(SPACE_REG_EXP(), '');

          if (chars.length > 1200) {
            this.state.ErrorMessages.push(intl.format(Errors.InputWrongMaxLength, {
              title: intl.format(Label.Contents),
              length: "1200"
            }));
          }
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        var contents = this.state.Contents;

        if (this.state.ContentsEditor != null) {
          contents = this.state.ContentsEditor.value;
        }

        contents = this.htmlEncode(contents);
        this.props.onEntry(this.state.Title, contents, startDateTime, endDateTime, this.state.OrganizationId, function () {
          if (_this2.state.Modal == null) {
            throw Error();
          }

          _this2.state.Modal.modal('hide');
        });
      }
    }
    /**
     * HTMLの特殊文字をエスケープします。
     *
     * @param html 対象のHTML
     */

  }, {
    key: "htmlEncode",
    value: function htmlEncode(html) {
      return html.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#039;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      var _this3 = this;

      if (this.state.Modal == null || !this.props.informationId) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;
        var startDateTime = Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes);
        var endDateTime = Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes);

        if (this.state.ContentsEditor != null) {
          var text = this.state.ContentsEditor.text;
          var chars = text.replace(SPACE_REG_EXP(), '');

          if (chars.length > 1200) {
            this.state.ErrorMessages.push(intl.format(Errors.InputWrongMaxLength, {
              title: intl.format(Label.Contents),
              length: "1200"
            }));
          }
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        if (!this.props.informationId || !this.props.updateDateTime) {
          throw Error();
        }

        var contents = this.state.Contents;

        if (this.state.ContentsEditor != null) {
          contents = this.state.ContentsEditor.value;
        }

        contents = this.htmlEncode(contents);
        this.props.onModify(this.props.informationId, this.state.Title, contents, startDateTime, endDateTime, this.state.OrganizationId, this.props.updateDateTime, function () {
          if (_this3.state.Modal == null) {
            throw Error();
          }

          _this3.state.Modal.modal('hide');
        });
      }
    }
    /**
     * 「削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "onDelete",
    value: function onDelete() {
      if (this.state.Modal == null || !this.props.informationId) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;
      this.props.onDelete(this.props.informationId, this.props.updateDateTime);
      this.state.Modal.modal('hide');
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onClose",
    value: function onClose() {
      if (this.state.Modal == null || !this.props.informationId) {
        throw Error();
      }

      this.state.ErrorMessages.length = 0;

      if (this.props.readed == 0) {
        this.props.onClose(this.props.informationId, this.props.updateDateTime);
      }

      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      var modal = $('#InformationModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this4.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");

      if (this.props.mode == Mode.ReadOnly) {
        this.setState({
          ContentsEditor: new Jodit('#Contents', {
            theme: 'whiteroom',
            readonly: true,
            toolbar: false,
            showCharsCounter: false,
            showWordsCounter: false,
            showXPathInStatusbar: false
          })
        });
      } else {
        this.setState({
          ContentsEditor: new Jodit('#Contents', {
            theme: 'whiteroom',
            toolbarAdaptive: false,
            buttons: ['bold', 'underline', '|', 'outdent', 'indent', '|', 'brush', '|', 'link'],
            showWordsCounter: false,
            showXPathInStatusbar: false
          })
        });
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "InformationModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, this.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_ManageNotification_Gray.svg"
      }), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_Notification_Gray.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Information.Title))), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        onClick: this.onClose.bind(this),
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), this.props.mode != Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Title"
      }, intl.format(Label.Title)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Title",
        id: "Title",
        readOnly: true,
        value: this.state.Title,
        tabIndex: 101
      }), this.props.mode != Mode.ReadOnly && [/*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Title",
        id: "Title",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 50,
        onChange: function onChange(e) {
          return _this5.updateTitle(e);
        },
        value: this.state.Title,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "50"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Title",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })])), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Contents"
      }, intl.format(Label.Contents)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("textarea", {
        className: "form-control",
        name: "Contents",
        id: "Contents",
        rows: 10,
        readOnly: true,
        value: this.state.Contents,
        tabIndex: 102
      }), this.props.mode != Mode.ReadOnly && [/*#__PURE__*/React.createElement("textarea", {
        className: "form-control",
        name: "Contents",
        id: "Contents",
        rows: 10,
        maxLength: 2000,
        onChange: function onChange(e) {
          return _this5.updateContents(e);
        },
        value: this.state.Contents,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "1,200"
        })
      })])), this.props.mode != Mode.ReadOnly && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "StartDate"
      }, intl.format(Label.PublishDate)), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "StartDate",
        id: "StartDate",
        tabIndex: 103,
        selected: this.state.StartDate,
        onChange: this.updateStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "InformationScope"
      }, intl.format(Label.InformationScope)), /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "InformationScope",
        name: "InformationScope",
        onChange: function onChange(e) {
          return _this5.updateInformationScope(e);
        },
        value: this.state.OrganizationId,
        tabIndex: 104
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, intl.format(OrganizationScopes.All)), /*#__PURE__*/React.createElement("option", {
        value: this.props.currentOrganizationId
      }, intl.format(OrganizationScopes.OnlyThis)))))], this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "StartDate"
      }, intl.format(Label.PublishDate)), /*#__PURE__*/React.createElement("label", {
        className: "col-5 col-form-label"
      }, this.state.StartDate != null ? this.state.StartDate.format("YYYY-MM-DD") : "")))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.props.mode == Mode.Add && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry)), this.props.mode == Mode.Modify && [/*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update)), /*#__PURE__*/React.createElement("button", {
        key: "onDelete",
        type: "button",
        className: "btn btn-default",
        onClick: this.onDelete.bind(this),
        tabIndex: -1
      }, intl.format(Action.Delete))], this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, intl.format(Action.Close))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };